export default "__VITE_ASSET__oqny_72l__"